__turbopack_context__.v({
  "panelHeader": "DeliveryHeaderPanel-module__bOYFfG__panelHeader",
});
